import { render, staticRenderFns } from "./FiPhoneInput.vue?vue&type=template&id=5077bcde&scoped=true&lang=pug&"
import script from "./FiPhoneInput.vue?vue&type=script&lang=js&"
export * from "./FiPhoneInput.vue?vue&type=script&lang=js&"
import style0 from "./FiPhoneInput.vue?vue&type=style&index=0&id=5077bcde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5077bcde",
  null
  
)

export default component.exports